import React, { useEffect, useState } from "react";

import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCardSubtitle,
  CCardTitle,
  CCol,
  CRow
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../actions/baseActions";
import Breadcrumb from "../../../../../components/Breadcrumb";
import Loading from "../../../../../components/Loading";
import ProtectedRoute from "../../../../../components/ProtectedRoute";
import SelectFilter from "../../../../../components/SelectFilter";
import DataTable from "../../../../../components/Tables/tables";
import URL from "../../../../../config/api";
import axios from "../../../../../config/axios";

const TrailGradeShow = props => {
  let [loading, setLoading] = useState();
  let [groupList, setGroupList] = useState();
  let [groupID, setGroupID] = useState(
    props.general.active_roles.group_id ?? null
  );

  let [regionList, setRegionList] = useState();
  let [regionID, setRegionID] = useState(
    props.general.active_roles.region_id ?? null
  );

  let [schoolList, setSchoolList] = useState();
  let [schoolID, setSchoolID] = useState(
    props.general.active_roles.school_id ?? null
  );

  let [classroomList, setClassroomList] = useState();
  let [classroomID, setClassroomID] = useState();

  let [trailList, setTrailList] = useState();
  let [trailID, setTrailID] = useState();

  let [trailLoading, setTrailLoading] = useState(false);
  let [usersTrailList, setUsersTrailList] = useState();

  let [loadingTrails, setLoadingTrails] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${URL.api}access/group/list`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        });

        const groupList = response.data?.data.map(group => ({
          label: group.name,
          value: group.id
        }));
        setGroupList(groupList);

        let group = props.general.active_roles.group_id ?? 0;
        let region = props.general.active_roles.region_id ?? 0;
        let school = props.general.active_roles.school_id ?? 0;

        if (group) {
          setGroupID(group);
          await getRegions(group);

          if (region) {
            setRegionID(region);
            await getSchools(region, group);
          } else {
            getTrails(group, null, null, null);
          }

          if (school) {
            setSchoolID(school);
            getClassList(school);
            // getTrails(group, region, school, null);
          } else {
            // getTrails(group, region, null, null);
          }
        }
      } catch {
        toastr.error("Falha", "Falha ao buscar os dados!");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getRegions = async id => {
    if (!id) {
      setRegionID(0);
      setSchoolID(0);
      setTrailID(0);
      classroomID(0);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/region/listRegionFilter/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const regionList = resp.data?.data.map(region => ({
            label: region.name,
            value: region.id
          }));
          setRegionList(regionList);
        });
    } catch {
      setRegionID(0);
      setSchoolID(0);
      classroomID(0);
    }
  };

  const getSchools = async (id, groupID) => {
    if (!id) {
      setSchoolID(0);
      classroomID(0);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/school/listSchoolFilter/${groupID}/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const schoolList = resp.data?.data.map(school => ({
            label: school.name,
            value: school.id
          }));
          setSchoolList(schoolList);
        });
    } catch {
      setSchoolID(0);
      classroomID(0);
    }
  };

  const getClassList = async schoolID => {
    axios
      .get(`${URL.api}community/room/list?class=true&school[]=${schoolID}`, {
        headers: {
          Authorization: `Bearer ${props.user.token}`
        }
      })
      .then(async resp => {
        const dateToday = new Date();
        const classroomFiltered = resp.data?.data.filter(
          classroom => new Date(classroom.end) > dateToday
        );

        const classroomList = await classroomFiltered.map(classroom => ({
          label: classroom.name,
          value: classroom.id
        }));
        setClassroomList(classroomList);
        setClassroomID(0);
        getTrails(groupID, regionID, schoolID, classroomID ?? null);
      });
  };

  const getTrails = (groupID, regionID, schoolID, classroomID) => {
    try {
      setLoadingTrails(true);
      axios
        .get(
          `${URL.api}activity/trail_allocation/statistics/getTrailsByFilter?group_id=${groupID}&region_id=${regionID}&school_id=${schoolID}&room_id=${classroomID}`,
          {
            headers: { Authorization: `Bearer ${props.user.token}` }
          }
        )
        .then(resp => {
          const trailList = resp.data?.data.map(trail => ({
            label: trail.name,
            value: trail.id
          }));
          setTrailList(trailList);
        })
        .finally(() => {
          setLoadingTrails(false);
        });
    } catch {
      setTrailID(0);
    }
  };

  const getUserList = async () => {
    setTrailLoading(true);
    await axios
      .get(
        `${
          URL.api
        }activity/trail_allocation/statistics/usersGradesInTrail/${trailID}?group_id=${groupID}${
          regionID ? `&region_id=${regionID}` : ""
        }${schoolID ? `&school_id=${schoolID}` : ""}
        ${classroomID ? `&room_id=${classroomID}` : ""}`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      )
      .then(resp => {
        let userList = [];

        resp?.data.forEach(user => {
          let userData = {
            name: "",
            step1: null,
            step2: null,
            step3: null,
            step4: null
          };
          userData.name = user.name;

          const getMaxGrade = stepList => {
            const result = stepList
              .filter(item => item.final_grade !== null) // Remove itens com final_grade null
              .reduce(
                (max, item) => Math.max(max, parseFloat(item.final_grade)),
                -Infinity
              )
              .toFixed(2);
            return result;
          };

          user?.evaluation_applications.forEach(evaluation => {
            switch (evaluation.step) {
              case 1: {
                const step1List = user.evaluation_applications.filter(
                  application => application.step === 1
                );
                if (step1List.some(item => item.final_grade !== null)) {
                  userData.step1 = getMaxGrade(step1List);
                } else {
                  userData.step1 = "Avaliação não realizada";
                }
                break;
              }
              case 2: {
                const step2List = user.evaluation_applications.filter(
                  application => application.step === 2
                );
                if (step2List.some(item => item.final_grade !== null)) {
                  userData.step2 = getMaxGrade(step2List);
                } else {
                  userData.step2 = "Avaliação não realizada";
                }
                break;
              }
              case 3: {
                const step3List = user.evaluation_applications.filter(
                  application => application.step === 3
                );
                if (step3List.some(item => item.final_grade !== null)) {
                  userData.step3 = getMaxGrade(step3List);
                } else {
                  userData.step3 = "Avaliação não realizada";
                }
                break;
              }
              case 4: {
                const step4List = user.evaluation_applications.filter(
                  application => application.step === 4
                );
                if (step4List.some(item => item.final_grade !== null)) {
                  userData.step4 = getMaxGrade(step4List);
                } else {
                  userData.step4 = "Avaliação não realizada";
                }
                break;
              }
            }
          });

          userList.push(userData);
        });
        userList = userList.map(user => ({
          name: user.name,
          step1: user.step1 ?? "Avaliação não realizada",
          step2: user.step2 ?? "Avaliação não realizada",
          step3: user.step3 ?? "Avaliação não realizada",
          step4: user.step4 ?? "Avaliação não realizada"
        }));
        setUsersTrailList(userList);
        setTrailLoading(false);
      });
  };

  return (
    <div>
      <Breadcrumb current={props.currentRoute} />
      <CCard>
        <CCardHeader>
          <CCardTitle>Visualização de Notas</CCardTitle>
          <CCardSubtitle className="small text-muted">
            Visualize as notas das trilhas em andamento
          </CCardSubtitle>
        </CCardHeader>
        <CCardBody>
          {loading ? (
            <Loading />
          ) : (
            <>
              <CCard className="d-flex justify-items-center justify-content-center p-4">
                <CRow>
                  <CCol sm="12" md="12">
                    <CRow>
                      <CCol sm="12" md="2" className="my-2">
                        <SelectFilter
                          title="Grupo"
                          icon="fa-users"
                          placeholder="Selecione um grupo"
                          value={groupID}
                          setFunction={id => {
                            setGroupID(id);
                            getRegions(id);
                            getTrails(id, null, null, null);
                          }}
                          options={groupList}
                          disabled={!!props.general.active_roles.group_id}
                        />
                      </CCol>
                      <CCol sm="12" md="2" className="my-2">
                        <SelectFilter
                          title="Regiões"
                          icon="fa-globe"
                          placeholder="Todas"
                          value={regionID}
                          setFunction={id => {
                            setRegionID(id);
                            getSchools(id, groupID);
                            getTrails(groupID, id, null, null);
                          }}
                          options={regionList}
                          disabled={
                            !groupID || !!props.general.active_roles.region_id
                          }
                        />
                      </CCol>
                      <CCol sm="12" md="2" className="my-2">
                        <SelectFilter
                          title="Escolas"
                          icon="fa-institution"
                          placeholder="Todas"
                          value={schoolID}
                          setFunction={id => {
                            setSchoolID(id);
                            getClassList(id);
                            getTrails(groupID, regionID, id, null);
                          }}
                          options={schoolList}
                          disabled={
                            !regionID || !!props.general.active_roles.school_id
                          }
                        />
                      </CCol>
                      <CCol sm="12" md="2" className="my-2">
                        <SelectFilter
                          title="Turmas"
                          icon="fa-graduation-cap"
                          placeholder="Todas"
                          value={classroomID}
                          setFunction={id => {
                            setClassroomID(id);
                            setTrailID(0);
                            getTrails(groupID, regionID, schoolID, id);
                          }}
                          options={classroomList}
                          disabled={!schoolID || !classroomList}
                        />
                      </CCol>
                      <CCol sm="12" md="2" className="my-2">
                        <SelectFilter
                          title="Trilha"
                          icon="fa-code-fork"
                          placeholder="Selecione uma trilha"
                          value={trailID}
                          setFunction={id => {
                            setTrailID(id);
                          }}
                          options={trailList}
                          disabled={
                            !groupID || trailList?.length === 0 || loadingTrails
                          }
                        />
                      </CCol>
                      <CCol
                        sm="12"
                        md="2"
                        className="d-flex justify-content-center my-2 align-items-end"
                      >
                        <CButton
                          color="primary"
                          className="d-flex justify-content-center align-items-center rounded-left w-100"
                          onClick={() => getUserList()}
                          disabled={!groupID || !trailID}
                        >
                          <i className="fa fa-filter" />
                          &nbsp; Filtrar
                        </CButton>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCard>
              {usersTrailList ? (
                <>
                  <DataTable
                    noSort
                    list={usersTrailList}
                    title="Estudantes"
                    subtitle="Lista de estudantes participantes da trilha"
                    header={[
                      { name: "name", denomination: "Estudante" },
                      { name: "step1", denomination: "Passo 1" },
                      { name: "step2", denomination: "Passo 2" },
                      { name: "step3", denomination: "Passo 3" },
                      { name: "step4", denomination: "Passo 4" }
                    ]}
                  />
                </>
              ) : (
                <>
                  {!trailLoading ? (
                    <p className="w-100 text-center">
                      Selecione ao menos o grupo e uma trilha para obter o
                      resultado.
                    </p>
                  ) : (
                    <Loading />
                  )}
                </>
              )}
            </>
          )}
        </CCardBody>
        <ProtectedRoute routeId={props.currentRoute} />
      </CCard>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch => bindActionCreators({ logout }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TrailGradeShow);
